export const links = [
    {
        "nombre" : "Agenda", 
        "link" : "/Agenda",
    },
    {
        "nombre" : "Transparencia", 
        "link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "Art. 69",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Art. 70",
                "subMenuUrl" : "/Art70"
            },
            {
                "subMenuNombre" : "MIR",
                "subMenuUrl" : "/Mir"
            },
            {
                "subMenuNombre" : "Recursos Federales",
                "subMenuUrl" : "/RecursosFederales"
            },
        ],
    },
    {
        "nombre" : "Trámites", 
        "link" : "/Tramites",
    },
    {
        "nombre" : "Licitaciones",
        "link" : "/Licitaciones",
        "submenu" : [
            {
                "subMenuNombre" : "Histórico 2026",
                "subMenuUrl" : "/Licitaciones/LicitacionesAnteriores/2026"
            },
            {
                "subMenuNombre" : "Histórico 2025",
                "subMenuUrl" : "/Licitaciones/LicitacionesAnteriores/2025"
            },
            {
                "subMenuNombre" : "Histórico 2024",
                "subMenuUrl" : "/Licitaciones/LicitacionesAnteriores/2024"
            },
            {
                "subMenuNombre" : "Histórico 2023",
                "subMenuUrl" : "/Licitaciones/LicitacionesAnteriores/2023"
            },
            {
                "subMenuNombre" : "Histórico 2022",
                "subMenuUrl" : "/Licitaciones/LicitacionesAnteriores/2022"
            },
            // {
            //     "subMenuNombre" : "Histórico 2021",
            //     "subMenuUrl" : "/Licitaciones/LicitacionesAnteriores/2021"
            // },
        ]
    },
    {
        "nombre" : "Interés", 
        "link" : "/Interes",
        "submenu" : [
            {
                "subMenuNombre" : "Construye Tu Camino",
                "subMenuUrl" : "/ConstruyeTuCamino"
            },
            {
                "subMenuNombre" : "Organismos",
                "subMenuUrl" : "/Organismos"
            },
            {
                "subMenuNombre" : "Residencias",
                "subMenuUrl" : "/Residencias"
            },
            {
                "subMenuNombre" : "Reconstruccion2025",
                "subMenuUrl" : "https://innovacion-sopot.hidalgo.gob.mx/view/public/?controller=sopot_works&view=works_georeference"
            },
            {
                "subMenuNombre" : "Atlas Carretero",
                "subMenuUrl" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/obrasp/doc/interes/atlas.pdf",
                "opcion" : "1"
            },
            {
                "subMenuNombre" : "Protocolo cero",
                "subMenuUrl" : "/ProtocoloCero",
            },
            {
                "subMenuNombre" : "Comité de Ética",
                "subMenuUrl" : "/ComiteEtica",
            },
        ],
    },
]